import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import { SnackbarService } from '../services/snackbar-service.service';
import { ModuloItemComponent } from './components/modulo-item/modulo-item.component';

@Component({
  selector: 'app-page-modules',
  templateUrl: './page-modules.component.html',
  styleUrls: ['./page-modules.component.scss']
})

export class PageModulesComponent implements OnInit {
  list: any[];
  viewModeActive: 'grilla' | 'lista' = 'grilla';
  unsubscribe$: Subject<any> = new Subject();
  constructor(
    private router: Router,
    public sessionService: SessionService,
    private snackbar: SnackbarService,
  ) {
  }

  ngOnInit(): void {
    
    this.list = (this.sessionService.getModulos() ?? []).map((modulo: any) => (
      {
      ...modulo,
    }));
    
  }

  toggleMode(mode: 'lista' | 'grilla'){
    this.viewModeActive = mode;
  }

  goModule(e: any, cardItem: ModuloItemComponent): void {
    this.sessionService.getTokenModulo(e.id).pipe(
      takeUntil(this.unsubscribe$),
      catchError(() => {
        //no snackeamos el error porque cuando es un error desde el interceptor ya se muestra en error-handler.service.ts
        cardItem.ngOnDestroy();
        // Retornamos un observable vacío o nulo para que el flujo termine controladamente
        return of(null); 
      })
    ).subscribe( resp => {
      if (!resp) return;
      this.snackbar.noMessage();

      const ruta = e.url || (e.modulo ? e.modulo.toLowerCase() : '');

      
      const token = localStorage.getItem('session') 
      ? JSON.parse(localStorage.getItem('session')!).token 
      : null;
      //si el módulo no es interno, lo redirigimos a la url cargada en el campo 'url'
      if (!e.interno) {
        
        if (token) {
          window.location.href = `${ruta}?token=${token}`;
        } else {
          this.router.navigate(['login']);
          this.snackbar.showMessage(`Su sesión ha expirado, inicie sesión de vuelta.`, 'warning');
        }
      } else {
        this.sessionService.reemplazarTokenLocal(resp);
        const navigation = this.router.navigate([ruta]);
        if (e.modulo) {
          this.sessionService.setModulo(e.modulo.toLowerCase());
        }


        //en el caso de que la ruta local no exista, se le advirtirá al usuario, y el loading del módulo se reseteará
        navigation.catch(() => {
          cardItem.setLoading(false);
          this.snackbar.showMessage(`La ruta "${ruta}" no está disponible.`, 'warning');
        });
      }
    });
  }





}
